import { render, staticRenderFns } from "./PreviousReview.vue?vue&type=template&id=404b48d0&scoped=true"
import script from "./PreviousReview.vue?vue&type=script&lang=js"
export * from "./PreviousReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404b48d0",
  null
  
)

export default component.exports